import React from 'react'
import { Button } from '@reapit/elements/core/button'
import { PageLayout } from '@reapit/elements/core/page-layout'
import {
  TechnicalDifficultiesContainer,
  TechnicalDifficultiesDescription,
  TechnicalDifficultiesMessagesContainer,
  TechnicalDifficultiesTitle,
} from './style'

/** Shown when the admin API's health check fails outright (not a 403 — that's AccessDeniedPage) — a genuine
 * outage rather than a permissions problem. */
export const TechnicalDifficultiesPage: React.FC = () => {
  return (
    <PageLayout id="technical-difficulties-page" scroll="self" backgroundColour="--colour-fill-neutral-lightest">
      <PageLayout.BodyRegion>
        <TechnicalDifficultiesContainer>
          <TechnicalDifficultiesMessagesContainer>
            <TechnicalDifficultiesTitle>We&apos;re Experiencing Technical Difficulties</TechnicalDifficultiesTitle>
            <TechnicalDifficultiesDescription>
              The Forms Admin service is temporarily unavailable. Please try again shortly.
            </TechnicalDifficultiesDescription>
          </TechnicalDifficultiesMessagesContainer>
          <Button variant="primary" size="medium" onClick={() => window.location.reload()} type="button">
            Retry
          </Button>
        </TechnicalDifficultiesContainer>
      </PageLayout.BodyRegion>
    </PageLayout>
  )
}

export default TechnicalDifficultiesPage
